import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {session} from '@netx/core-auth/collections/singleton/session';

export const canLogout = () => {
	return !isBrandPortal() || !session.isAuthenticatedAsPublicUser();
};
